import { useParams } from 'react-router-dom';
import cn from 'bem-cn';

import { Stack } from '../UI';
import { useGetAchievementsQuery } from '../../store';
import { AchievementList } from '../AchievementList';

import './ProfileAchievements.scss';

const b = cn('profile-achievements');

export const ProfileAchievements = () => {
    const { loginOrPublicId } = useParams<{ loginOrPublicId: string }>();

    const { data, isFetching } = useGetAchievementsQuery({ loginOrPublicId });

    return (
        <Stack className={b()}>
            <Stack direction="row" justifyContent="space-between" className={b('header')}>
                <Stack spacing={8} className={b('season-container')}>
                    <h2>Сезон 1</h2>
                    <p>(15 декабря – 15 июня)</p>
                </Stack>
                {/* <Icon name="faq" fillColor="var(--accent-color)" /> */}
            </Stack>
            <AchievementList achievements={data} isLoading={isFetching} />
        </Stack>
    );
};
